// Helper único para a regra de venda dos produtos da Distribuidora Santa Ana:
// - Todos os produtos são vendidos APENAS por CAIXA
// - Exceção: produtos da categoria "Laços" são vendidos por PACOTE de 20 unidades
// O preço usado é sempre `valor_caixa` (ou `valor_por_caixa` como fallback).

const norm = (s) =>
  (s || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export function isLacosProduct(product) {
  if (!product) return false;
  const cat = norm(product.categoria);
  return cat.includes('laco') || cat.includes('lacos');
}

/** Retorna { tipo: 'caixa'|'pacote', label: string, preco: number, qtdPorPacote: number|null } */
export function getProductSalesUnit(product) {
  const preco = Number(product?.valor_caixa || product?.valor_por_caixa || 0) || 0;
  if (isLacosProduct(product)) {
    return {
      tipo: 'pacote',
      label: 'Pacote (20un)',
      preco,
      qtdPorPacote: 20,
    };
  }
  return {
    tipo: 'caixa',
    label: 'Caixa',
    preco,
    qtdPorPacote: null,
  };
}
